module.exports = __webpack_public_path__ + "static/media/acessibilidade.42dc6002.gif";